import React from 'react';
import Paper from '@mui/material/Paper';
import Button from '@mui/material/Button';
import CheckBoxChecked from '@mui/icons-material/CheckBox';
import CheckBoxBlank from '@mui/icons-material/CheckBoxOutlineBlankOutlined';
import Grid from '@mui/material/Grid';

import FormGroup from '@mui/material/FormGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormControl from '@mui/material/FormControl';
import FormLabel from '@mui/material/FormLabel';
import Checkbox from '@mui/material/Checkbox';

import MeldungMetadaten from '../Entity/MeldungMetadaten'
import UnterschriftHaken from '../Components/UnterschriftHaken';
import personEntity from '../Entity/person';
import ortEntity from '../Entity/ort';
import validatorResult from '../Entity/validatorResult';
import MeldungWurdeVersandt from '../Components/MeldungWurdeVersandt';
import Person from '../Components/Person';
import Ort from '../Components/Ort';
import BA_RechtlicheBelehrung from '../Components/Hilfe/Artenschutz/BA_RechtlicheBelehrung';
import Fehlerbox from '../Components/Fehlerbox';
import Creatures from '../Components/Creatures';
import CreatureEntity, {role_parent, role_child} from '../Entity/Creature';
import LitterEntity from '../Entity/Litter';
import CreatureConfigFields from '../Entity/CreatureConfigFields';

import CustomDatePickerFieldNGX from "../Components/CustomDatePickerFieldNGX";
import CustomSelectFieldNGX from '../Components/CustomSelectFieldNGX';
//import CustomList from '../Components/CustomList';

import ValidatorPerson from '../Module/Validatoren/ValidatorPerson';
import ValidatorOrt from '../Module/Validatoren/ValidatorOrt';

//import ListeHerkunftCodes from '../Components/Cites/ListeHerkunftCodesFauna';
//import ListeBesitzberechtigung from '../Components/Cites/ListeBesitzberechtigung';
import Zoom from '@mui/material/Zoom';
import Collapse from '@mui/material/Collapse';

import {
  Standard as StandardDataField
} from "../Entity/Kennzeichnung/StandardDataFields";

import {updateValue, addEntityToState, removeEntityFromState} from '../Actions';

const style = {

  paper: {
    padding:"10px 20px 10px 20px",
  },
  checkboxItem: {
    paddingTop:"18px",
  },
  FormNumber: {
    display:"inline-block",
    border:"2px solid black",
    padding:"0 5px 0 5px",
  },
}

const configCreatureExemplar = () => {
  let crtrConf = CreatureConfigFields()
  let crtr = CreatureEntity(crtrConf)
  crtr.kennzeichnungAnpassen.geschlechtsverhaeltnis = true
  return crtr;
}

const configCreatureParent = () => {
  let crtrConf = CreatureConfigFields()
  let crtr = CreatureEntity(crtrConf)
  crtr.role = role_parent
  crtr.kennzeichnungAnpassen.geschlechtsverhaeltnis = false

  return crtr;
}

const configCreatureChild = () => {
  let crtrConf = CreatureConfigFields()
  let crtr = CreatureEntity(crtrConf)
  crtr.role = role_child
  crtr.kennzeichnungAnpassen.geschlechtsverhaeltnis = true
  crtr.kennzeichnungAnpassen.citesBescheinigungUnterdruecken = true
  return crtr;
}

const addLitter = (dispatch) => () => {
  let litter = LitterEntity()
  dispatch(addEntityToState(['creatures', litter.uniqueId],litter))

  let firstParent = configCreatureParent()
  //dispatch(addEntityToState(['creatures', litter.uniqueId, "parents", firstParent.uniqueId], firstParent))
  let secondParent = configCreatureParent()
  //dispatch(addEntityToState(['creatures', litter.uniqueId, "parents", secondParent.uniqueId], secondParent))

  let firstChild = configCreatureChild()
  //dispatch(addEntityToState(['creatures', litter.uniqueId, "children", firstChild.uniqueId], firstChild))
}

const configHalter = () => {
  let halter = personEntity()
  halter.geburtsdatum.required = true
  //  halter.email.required = true
  //halter.telefon.required = true
  halter.personTyp.display = true
  return halter;
}

const configVorbesitzer = () => {
  let vorbesitzer = personEntity()
  vorbesitzer.strasse.required = false
  vorbesitzer.hausnummer.required = false
  vorbesitzer.plz.required = false
  vorbesitzer.ort.required = false
  return vorbesitzer;
}

export default class FormularMeldung extends React.Component {

  constructor (props) {
    super(props);

    this.props.data['halter'] = configHalter()
    this.props.data.MeldungMetadaten = MeldungMetadaten()
    //this.props.data['unterschriftHalter'] = signatureEntity()

    this.props.data['artDesErwerbs'] = StandardDataField('')
    this.props.data['erwerbsdatum'] = StandardDataField('')
    this.props.data['rueckgabedatum'] = StandardDataField('')
    this.props.data['verwendungszweck'] = StandardDataField('')
    this.props.data['besitzgrund'] = StandardDataField('')
    this.props.data['besitzberechtigung'] = StandardDataField('')
    this.props.data['codeHerkunft'] = StandardDataField('')

    this.props.data['halterIstEigentuemer'] = StandardDataField(null)


    this.props.data.creatures = {}

    if (this.props.zeigeVorbesitzer) {
      let vorbesitzer = configVorbesitzer()
      vorbesitzer.personTyp.display = true
      this.props.dispatch(addEntityToState(['vorbesitzer'],vorbesitzer))
    }

    if (this.props.zeigeVorbesitzer === true) {
      let creature = configCreatureExemplar()
      this.props.dispatch(addEntityToState(['creatures', creature.uniqueId],creature))
    }

    if (this.props.zeigeNachzucht === true) {
      addLitter(this.props.dispatch)()
    }

  }

  checkbox = (value) => {
    if (value === true) {
        return <CheckBoxChecked/>
    }
    return <CheckBoxBlank/>
  }

  updateValue = (pathGroupName) => (pathValueName) => (value) => {
    this.props.dispatch(updateValue(pathGroupName+'.'+pathValueName+'.value', value))
  }

  updateTouch = (pathGroupName) => (pathValueName) => () => {
    this.props.dispatch(updateValue(pathGroupName+'.'+pathValueName+'.touched', true))
  }

  updateValid = (pathGroupName) => (pathValueName) => (value) => {
    this.props.dispatch(updateValue(pathGroupName+'.'+pathValueName+'.valid', value))
  }

  updateMsg = (pathGroupName) => (pathValueName) => (value) => {
    this.props.dispatch(updateValue(pathGroupName+'.'+pathValueName+'.msg', value))
  }

  dispatchChoice = (pathGroupName) => (pathValueName) => (value) => {
    this.props.dispatch(updateValue(pathGroupName+'.'+pathValueName+'.value', value))
  }

  dispatchAddEntity = (entityStateName, entity)  => {
    this.props.dispatch(updateValue(entityStateName, entity))
  }

  renderHaltungsort = (payload) => {
    return (
      <Paper style={style.paper}>
        <FormControl component="fieldset">
          <FormLabel component="legend">Haltungsort der Exemplare</FormLabel>
          <FormGroup aria-label="position" row>

            <FormControlLabel
              value="top"
              control={
                <Checkbox
                  onChange={()=>{
                    if (this.props.data.MeldungMetadaten.wohnortIstHaltungsort.value) {
                      if (!confirm("Wollen Sie angeben, dass die Tiere bei Ihnen zuhause gehalten werden? Ihre Angaben zum abweichenden Haltungsort werden gelöscht!"))
                      return;
                    }

                    this.props.dispatch(removeEntityFromState('haltungsort'))
                    this.props.dispatch(updateValue('MeldungMetadaten.wohnortIstHaltungsort.value', false))
                  }}
                  checked={this.props.data.MeldungMetadaten.wohnortIstHaltungsort.value === false}
                  sx={{ '& .MuiSvgIcon-root': { fontSize: 28 }}}
                />
              }
              label="Anschrift ist Haltungsort"
              labelPlacement="end"
            />

            <FormControlLabel
              value="top"
              control={
                <Checkbox
                  onChange={()=>{
                    this.props.dispatch(addEntityToState('haltungsort',ortEntity()))
                    this.props.dispatch(updateValue('MeldungMetadaten.wohnortIstHaltungsort.value', true))
                  }}
                  checked={this.props.data.MeldungMetadaten.wohnortIstHaltungsort.value === true}
                  sx={{ '& .MuiSvgIcon-root': { fontSize: 28 }}}
                />
              }
              label="Exemplare werden an einem anderen Ort gehalten"
              labelPlacement="end"
            />

          </FormGroup>
        </FormControl>

        {payload}
      </Paper>
    )
  }

  touchAll = (obj, group) => {
    for (let item in obj) {
      if (obj[item].hasOwnProperty("touched")) {
        this.updateTouch(group)(item)()
      }
    }
  }

  validatorHalterResult = (halter) => {

    if (!halter.meta.touched) {
      return []
    }

    var res = ValidatorPerson(halter, true)
    if ( res.valid === true ) {
      return [];
    }

    var display = [];
    res.message.map(
    (el) => display.push(<p key={el}>{el}</p>)
    )

    return display;

  }

  validatorHaltungsortResult = (haltungsort) => {
    if (!haltungsort.meta.touched) {
      return []
    }

    var res = ValidatorOrt(haltungsort)

    if ( res.valid === true ) {
      return [];
    }
    var display = [];
    res.message.map(
    (el) => display.push(<p key={el}>{el}</p>)
    )

    return display;
  }

  buttonPruefen = (label) => (
    <Button
      onClick={()=>{
        this.updateValue("meta")("touched")(true)

        if (this.props.data.hasOwnProperty("haltungsort")) {
          this.touchAll(this.props.data.haltungsort, 'haltungsort')
        }
        if (this.props.data.hasOwnProperty("halter")) {
          this.touchAll(this.props.data.halter, 'halter')
        }
        if (this.props.data.hasOwnProperty("eigentuemer")) {
          this.touchAll(this.props.data.eigentuemer, 'eigentuemer')
        }
        if (this.props.data.hasOwnProperty("vorbesitzer")) {
          this.touchAll(this.props.data.vorbesitzer, 'vorbesitzer')
        }

        if (this.props.data.hasOwnProperty("artDesErwerbs")) {
          this.props.updateStandard('touched')('artDesErwerbs')()(true)
        }
        
        if (this.props.data.hasOwnProperty("erwerbsdatum")) {
          this.props.updateStandard('touched')('erwerbsdatum')()(true)
        }

        if (this.props.data.hasOwnProperty("verwendungszweck")) {
          this.props.updateStandard('touched')('verwendungszweck')()(true)
        }

        if (this.props.data.hasOwnProperty("besitzgrund")) {
          this.props.updateStandard('touched')('besitzgrund')()(true)
        }

        if (this.props.data.hasOwnProperty("besitzberechtigung")) {
          this.props.updateStandard('touched')('besitzberechtigung')()(true)
        }

        if (this.props.data.hasOwnProperty("codeHerkunft")) {
          this.props.updateStandard('touched')('codeHerkunft')()(true)
        }

        if (
          this.props.data.hasOwnProperty("creatures") 
          && Object.keys(this.props.data.creatures).length > 0
        ) {
          Object.keys(this.props.data.creatures).map(
            (element) => {
              this.touchAll(this.props.data.creatures[element], "creatures."+element)
              if (Object.keys(this.props.data.creatures[element].children).length>0) {
                for (let item in this.props.data.creatures[element].children) {
                  this.touchAll(this.props.data.creatures[element].children[item], "creatures."+element+".children."+item)
                }
              }
            }
          )
        }
  
      }}
      variant="contained"
      color="primary"
      size="large"
      fullWidth={true}
    >
      &nbsp;<br/> {label}<br/>&nbsp;
    </Button>
  )

  absenden = () => {

    if (this.props.data.meta.touched.value !== true) {
      return this.buttonPruefen("Angaben Prüfen");
    }

    var msg = []

    if ( !ValidatorPerson(this.props.data.halter,true).valid ) {
      msg.push(
        <p key="ERR.Person">
          Fehler bei Angaben zum Halter. Bitte korrigieren Sie zunächst die markierten Felder.
        </p>
      )
    }

    if ( this.props.data.halterIstEigentuemer.value === "" ) {
      msg.push(
        <p key="ERR.HHalterIstEigentuemer">
          Fehlende Angabe zu Halter und Eigentümer. Bitte geben Sie an, ob der Halter auch Eigentümer ist.
        </p>
      )
    }

    if ( 
      this.props.data.hasOwnProperty("eigentuemer") &&
      !ValidatorPerson(this.props.data.eigentuemer).valid 
    ) {
      msg.push(
        <p key="ERR.Eigentuemer">
          Fehler beim Eigentümer. Bitte korrigieren Sie zunächst die markierten Felder.
        </p>
      )
    }

    if ( 
      this.props.data.MeldungMetadaten.wohnortIstHaltungsort.value !== false
      && this.props.data.MeldungMetadaten.wohnortIstHaltungsort.value !== true
    ) {
      msg.push(
        <p key="ERR.HOrtEntscheidung">
          Fehlende Angabe beim Haltungsort. Bitte machen Sie Angaben zum Haltungsort.
        </p>
      )
    }

    if ( 
      this.props.data.hasOwnProperty("haltungsort") &&
      !ValidatorOrt(this.props.data.haltungsort).valid 
    ) {
      msg.push(
        <p key="ERR.HOrt">
          Fehler beim Haltungsort. Bitte korrigieren Sie zunächst die markierten Felder.
        </p>
      )
    }

    if ( 
      this.props.data.hasOwnProperty("vorbesitzer") &&
      !ValidatorPerson(this.props.data.vorbesitzer).valid 
    ) {
      msg.push(
        <p key="ERR.Vorbesitzer">
          Fehler beim Vorbesitzer. Bitte korrigieren Sie zunächst die markierten Felder.
        </p>
      )
    }

    if (!this.props.zeigeNachzucht && !this.props.data.artDesErwerbs.value) {
      msg.push(
        <p key="ERR.artDesErwerbs">
          Fehlende Angabe zur Art des Erwerbs.
        </p>
      )
    }

    if (!this.props.zeigeNachzucht && this.props.data.erwerbsdatum.value === "" ) {
      msg.push(
        <p key="ERR.Erwerbsdatum">
          Fehlende Angabe zum Erwerbsdatum.
        </p>
      )
    }
/*
    if ( this.props.data.verwendungszweck.value === "" ) {
      msg.push(
        <p key="ERR.Verwendungszweck">
          Fehlende Angabe zum Verwendungszweck.
        </p>
      )
    }

    if ( !this.props.data.besitzgrund.value ) {
      msg.push(
        <p key="ERR.besitzgrund">
          Fehlende Angabe zum Besitzgrund.
        </p>
      )
    }

    if ( !this.props.data.besitzberechtigung.value ) {
      msg.push(
        <p key="ERR.besitzberechtigung">
          Fehlende Angabe zur Besitzberechtigung.
        </p>
      )
    }

    if ( !this.props.data.codeHerkunft.value ) {
      msg.push(
        <p key="ERR.codeHerkunft">
          Fehlende Angabe zur Herkunft.
        </p>
      )
    }
*/
    if ( Object.keys(this.props.data.creatures).length < 1 ) {
      msg.push(
        <p key="ERR.CreaturesLength">
          Keine Exemplare zur Meldung vorhanden. Bitte melden Sie zumindest ein Exemplar an.
        </p>
      )
    }


    let countCreatures = 0;
    for (let uniqueId in this.props.data.creatures) {
      countCreatures++
      if (
        this.props.data.creatures[uniqueId].hasOwnProperty("spezies") &&
        (
          !this.props.data.creatures[uniqueId].spezies.hasOwnProperty("wiss")
          || this.props.data.creatures[uniqueId].spezies.wiss == ""
        )
      ) {
        msg.push(
          <p key={"ERR.Spec"+uniqueId}>
            Für das {countCreatures}. Tier wurde die Spezies nicht korrekt ausgewählt.
          </p>
        )
      }
    }

    if ( 
      this.props.data.meta.unterschrifthaken.value !== true
    ) {
      msg.push(
        <p key="ERR.UnterschriftHaken">
          Bitte bestätigen Sie, dass Ihre Angaben richtig und vollständig sind.
        </p>
      )
    }

    if (msg.length < 1) {
      return this.props.absenden(
        "Jetzt rechtsverbindlich einreichen/abschicken.",
        false,
        ()=>{
          this.updateValue('meta')('wurdeVersandt')(true)
        }  
      )
    } else {
      return (
        <div>
          <Fehlerbox
            inhalt={msg}
          />
          <div style={{marginTop:"25px"}}></div>
          {this.props.absenden(
            "Jetzt rechtsverbindlich einreichen/abschicken.", 
            true,
            ()=>{
              this.updateValue('meta')('wurdeVersandt')(true)
            }
          )}
        </div>
      )
    }

  }

  render = () => {

    if (this.props.data.meta.wurdeVersandt.value) {
      return (
        <MeldungWurdeVersandt>
          Die Meldung wurde erfolgeich versandt.
        </MeldungWurdeVersandt>
      );
    }

    return (
      <div>

        {this.props.titel}
  
        <div style={{marginTop:"25px"}}></div>

        <BA_RechtlicheBelehrung/>
  
        <div style={{marginTop:"25px"}}></div>

        <Person
          id="PersonHalter"
          headline="Halter"
          withCard={true}
          data={this.props.data.halter}
          updaterValue={this.updateValue('halter')}
          updaterTouch={this.updateTouch('halter')}
          updaterValid={this.updateValid('halter')}
          updaterMsg={this.updateMsg('halter')}
          restLadePlz={this.props.konfiguration.restPath + 'plz.php'}
          konfiguration = {this.props.konfiguration.importierteKonfiguration.halter}
        />

        <Fehlerbox
            inhalt={this.validatorHalterResult(this.props.data.halter)}
         />

        <div style={{marginTop:"25px"}}></div>

        {!this.props.zeigeNachzucht &&
          <Paper style={style.paper}>
          <FormControl component="fieldset">
            <FormLabel component="legend">Ist Halter auch Eigentümer?</FormLabel>
            <FormGroup aria-label="position" row>
              <FormControlLabel
                value="top"
                control={
                  <Checkbox
                    onChange={
                      () => {
                        if (this.props.data.halterIstEigentuemer.value == true) {
                          this.props.updateStandard('value')('halterIstEigentuemer')()(null)
                          return;
                        }
                        this.props.updateStandard('value')('halterIstEigentuemer')()(true)
                        this.props.removeStandard(['eigentuemer'])()()
                        return;
                      }
                    }
                    checked={this.props.data.halterIstEigentuemer.value === true}
                    sx={{ '& .MuiSvgIcon-root': { fontSize: 28 }}}
                  />
                }
                label="Halter ist Eigentümer"
                labelPlacement="end"
              />
              <FormControlLabel
                value="top"
                control={
                  <Checkbox
                    onChange={
                      () => {
                        if (this.props.data.halterIstEigentuemer.value == false) {
                          this.props.updateStandard('value')('halterIstEigentuemer')()(null)
                          this.props.removeStandard(['eigentuemer'])()()
                          return;
                        }
                        this.props.updateStandard('value')('halterIstEigentuemer')()(false)
                        this.props.updateStandard()('eigentuemer')()(configHalter())
                        return;
                      }
                    }
                    checked={this.props.data.halterIstEigentuemer.value === false}
                    sx={{ '& .MuiSvgIcon-root': { fontSize: 28 }}}
                  />
                }
                label={<span>Halter ist <u>nicht</u> Eigentümer</span>}
                labelPlacement="end"
              />

            </FormGroup>
          </FormControl>
        </Paper>
      }


      {this.props.data.hasOwnProperty("eigentuemer") === true  &&
        <Zoom in={true} timeout={500}>
          <div style={{marginTop:"25px"}}>
            <Person
              id="PersonEigentuemer"
              headline="Eigentümer"
              withCard={true}
              data={this.props.data.eigentuemer}
              updaterValue={this.updateValue('eigentuemer')}
              updaterTouch={this.updateTouch('eigentuemer')}
              updaterValid={this.updateValid('eigentuemer')}
              updaterMsg={this.updateMsg('eigentuemer')}
              restLadePlz={this.props.konfiguration.restPath + 'plz.php'}
              konfiguration = {this.props.konfiguration.importierteKonfiguration.eigentuemer}
            />
            
            <Fehlerbox
                inhalt={this.validatorHalterResult(this.props.data.eigentuemer)}
            />
          </div>
        </Zoom>
      }

      <div style={{marginTop:"25px"}}></div>

      {this.renderHaltungsort(
        <Collapse in={this.props.data.hasOwnProperty('haltungsort')} timeout={500}>
        <div>
          {this.props.data.hasOwnProperty('haltungsort') &&
            <div>
              <Ort
                id="StandardHaltungsort"
                headline="Haltungsort"
                data={this.props.data.haltungsort}
                withAvatar={true}
                updaterValue={this.updateValue('haltungsort')}
                updaterTouch={this.updateTouch('haltungsort')}
                updaterValid={this.updateValid('haltungsort')}
                restLadePlz={this.props.konfiguration.restPath + 'plz.php'}
              />

              <Fehlerbox
                inhalt={this.validatorHaltungsortResult(this.props.data.haltungsort)}
              />
            </div>
          }
        </div>
        </Collapse>
      )}


        <div style={{marginTop:"25px"}}></div>

        {this.props.zeigeVorbesitzer === true && this.props.data.hasOwnProperty("vorbesitzer")  &&
          <div>
            <Person
              id="PersonVorbesitzer"
              headline="Vorbesitzerin/Vorbesitzer"
              withCard={true}
              data={this.props.data.vorbesitzer}
              updaterValue={this.updateValue('vorbesitzer')}
              updaterTouch={this.updateTouch('vorbesitzer')}
              updaterValid={this.updateValid('vorbesitzer')}
              updaterMsg={this.updateMsg('vorbesitzer')}
              restLadePlz={this.props.konfiguration.restPath + 'plz.php'}
              konfiguration = {this.props.konfiguration.importierteKonfiguration.vorbesitzer}
            >
              <Grid container spacing={2} style={{marginTop:"0px"}}>
                <Grid item xs={6}>
                  <CustomSelectFieldNGX
                    id={"artDesErwerbs"}
                    label="Art des Erwerbs"
                    value={this.props.data['artDesErwerbs'].value}
                    updaterValue={this.props.updateStandard('value')('artDesErwerbs')()}
                    touched={this.props.data['artDesErwerbs'].touched}
                    updaterTouch={this.props.updateStandard('touched')('artDesErwerbs')()}
                    list={[
                        {
                            id:'Kauf',
                            label:'Kauf',
                        },
                        {
                          id:'Leihgabe',
                          label:'Leihgabe',
                      },
                        {
                          id:'Erbschaft',
                          label:'Erbschaft',
                        },
                        {
                          id:'Schenkung',
                          label:'Schenkung',
                        },
                        {
                          id:'Ueberlassung',
                          label:'Behördliche Überlassung/Pflege',
                        },              
                        {
                          id:'gefunden',
                          label:'gefunden/zugeflogen/zugelaufen',
                        },
                    ]}
                    required={true}
                    validator={()=>{
                      if( this.props.data.artDesErwerbs.touched && !this.props.data.artDesErwerbs.value ) {
                        this.props.updateStandard('valid')('artDesErwerbs')(false)
                        return validatorResult(false, "Bitte treffen Sie eine Auswahl");
                      }
                      return validatorResult(true);
                    }}
                  />
                </Grid>    
                <Grid item xs={6}>
                  <CustomDatePickerFieldNGX
                    id={"Erwerbsdatum"}
                    label="Datum des Zugangs"
                    required={true}
                    value={this.props.data.erwerbsdatum.value}
                    touched={this.props.data.erwerbsdatum.touched}
                    updaterValue={this.props.updateStandard('value')('erwerbsdatum')()}
                    updaterTouch={this.props.updateStandard('touched')('erwerbsdatum')()}
                    ariaLabel="Datum des Zugangs angeben"
                    validator={()=>{
                      if( this.props.data.erwerbsdatum.touched && !this.props.data.erwerbsdatum.value ) {
                        this.props.updateStandard('valid')('erwerbsdatum')(false)
                        return validatorResult(false, "Bitte treffen Sie eine Auswahl");
                      }
                      return validatorResult(true);
                    }}
                  />
                </Grid>
                {this.props.data.artDesErwerbs.value == "Leihgabe" &&
                  <Grid item xs={12} md={8} lg={6}>
                    <CustomDatePickerFieldNGX
                      id={"Rueckgabedatum"}
                      label="Voraussichtliches Datum der Rückgabe (sofern bekannt)"
                      required={false}
                      enableFuture={true}
                      value={this.props.data.rueckgabedatum.value}
                      touched={this.props.data.rueckgabedatum.touched}
                      updaterValue={this.props.updateStandard('value')('rueckgabedatum')()}
                      updaterTouch={this.props.updateStandard('touched')('rueckgabedatum')()}
                      ariaLabel="Voraussichtliches Datum der Rückgabe angeben"
                      validator={()=>{
                        return validatorResult(true);
                      }}
                    />
                  </Grid>
                }
                {this.props.data.artDesErwerbs.value == "Leihgabe" &&
                  <Grid item xs={12}>
                    Bitte laden Sie bei Bedarf entsprechende Dokumente (Überlassungsvertrag) bei den 
                    jeweiligen Exemplaren unter "DOKUMENTE HINZUFÜGEN" hoch.
                  </Grid>
                }
              </Grid>
            </Person>
            
            <Fehlerbox
                inhalt={this.validatorHalterResult(this.props.data.vorbesitzer)}
            />
          </div>
        }

        <div style={{marginTop:"25px"}}></div>        
        {/*
        <Paper style={style.paper}>

          <div style={{marginTop:"25px"}}></div>        

          <CustomSelectFieldNGX
            id={"verwendungszweck"}
            label="Verwendungszweck"
            value={this.props.data['verwendungszweck'].value}
            updaterValue={this.props.updateStandard('value')('verwendungszweck')()}
            touched={this.props.data['verwendungszweck'].touched}
            updaterTouch={this.props.updateStandard('touched')('verwendungszweck')()}
            list={[
                {
                  id:'Gewerbe',
                  label:'Gewerbe',
                },
                {
                  id:'Haustier',
                  label:'Haustier',
                },
                {
                  id:'Hobby',
                  label:'Hobby',
                },
                {
                  id:'Jagd',
                  label:'Jagd',
                },
                {
                  id:'Pflegefall',
                  label:'Pflegefall',
                },
                {
                  id:'Wissenschaft',
                  label:'Wissenschaft',
                },
                {
                  id:'Zucht',
                  label:'Zucht',
                }                    
            ]}
            required={true}
            validator={()=>{
              if( this.props.data.verwendungszweck.touched && !this.props.data.verwendungszweck.value ) {
                this.props.updateStandard('valid')('verwendungszweck')(false)
                return validatorResult(false, "Bitte treffen Sie eine Auswahl");
              }
              return validatorResult(true);
            }}
          />

          <div style={{marginTop:"25px"}}></div>        

          <CustomSelectFieldNGX
            id={"besitzgrund"}
            label="Besitzgrund"
            value={this.props.data['besitzgrund'].value}
            updaterValue={this.props.updateStandard('value')('besitzgrund')()}
            touched={this.props.data['besitzgrund'].touched}
            updaterTouch={this.props.updateStandard('touched')('besitzgrund')()}
            list={[
                {
                  id:'Eigenzucht',
                  label:'Eigenzucht',
                },
                {
                  id:'Gefunden',
                  label:'gefunden/zugefolgen/zugelaufen',
                },
                {
                  id:'Uebernahme',
                  label:'Kauf/Übernahme von Dritten',
                },
                {
                  id:'Naturentnahme',
                  label:'Naturentnahme',
                }                    
            ]}
            required={true}
            validator={()=>{
              if( this.props.data.besitzgrund.touched && !this.props.data.besitzgrund.value ) {
                this.props.updateStandard('valid')('besitzgrund')(false)
                return validatorResult(false, "Bitte treffen Sie eine Auswahl");
              }
              return validatorResult(true);
            }}
          />

          <div style={{marginTop:"25px"}}></div>        

          <CustomSelectFieldNGX
            id={"besitzberechtigung"}
            label="Besitzberechtigung"
            value={this.props.data['besitzberechtigung'].value}
            updaterValue={this.props.updateStandard('value')('besitzberechtigung')()}
            touched={this.props.data['besitzberechtigung'].touched}
            updaterTouch={this.props.updateStandard('touched')('besitzberechtigung')()}
            list={ListeBesitzberechtigung}
            required={true}
            validator={()=>{
              if( this.props.data.besitzberechtigung.touched && !this.props.data.besitzberechtigung.value ) {
                this.props.updateStandard('valid')('besitzberechtigung')(false)
                return validatorResult(false, "Bitte treffen Sie eine Auswahl");
              }
              return validatorResult(true);
            }}
          />

          <div style={{marginTop:"25px"}}></div>        

          <CustomList
            id={"codeHerkunft"}
            label="Herkunft"
            value={this.props.data['codeHerkunft'].value}
            updaterValue={this.props.updateStandard('value')('codeHerkunft')()}
            touched={this.props.data['codeHerkunft'].touched}
            updaterTouch={this.props.updateStandard('touched')('codeHerkunft')()}
            variant="list"
            list={ListeHerkunftCodes}
            required={true}
            validator={()=>{
              if( this.props.data.codeHerkunft.touched && !this.props.data.codeHerkunft.value ) {
                this.props.updateStandard('valid')('codeHerkunft')(false)
                return validatorResult(false, "Bitte treffen Sie eine Auswahl");
              }
              return validatorResult(true);
            }}
          />

          <div style={{marginTop:"25px"}}></div>        

      </Paper>
      */}

        <div style={{marginTop:"25px"}}></div>        

        <Creatures
          form={this.props.form}
          data={this.props.data}
          creatures={this.props.data.creatures}
          dispatch={this.props.dispatch}
          updaterValue={this.updateValue}
          updaterTouch={this.updateTouch}
          updaterValid={this.updateValid}
          konfiguration={this.props.konfiguration}
          creatureExemplar={
            this.props.zeigeVorbesitzer ? configCreatureExemplar : null
          }
          creatureParent={
            this.props.zeigeNachzucht ? configCreatureParent : null
          }
          creatureChild={configCreatureChild}
          addLitter={addLitter(this.props.dispatch)}
          restLadeSpezies={this.props.konfiguration.restPath + 'spezies.php'}
          restPath={this.props.konfiguration.restPath}
          kennzeichnungAnpassen={true}
        />

        {/*this.signature()*/}

        <div style={{marginTop:"25px"}}></div>

        <UnterschriftHaken 
          value={this.props.data.meta.unterschrifthaken.value}
          update={this.updateValue("meta")("unterschrifthaken")}
        />

        {this.absenden()}

      </div>
    )
  }

}